import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";

const certificationExamResultsReducer = createAsyncReducer({
    name: 'certificationExamResults',
    initialState: {
        records: {},
        loading: false,
        errorMessage: ''
    },
    reducers: (create) => ({
        query: create.asyncThunk(
            async (search) => {
                return Fetch.get(Routes.ajax_certification_exam_results_path(search));
            },
            {
                pending: (state, action) => {
                    state.loading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.records = {...state.records, ...action.payload};
                },
                rejected: (state, action) => {
                    state.loading = false;
                    state.errorMessage = action.error;
                }
            }
        ),
    })
});

export default certificationExamResultsReducer;